import { motion } from "framer-motion";
import { reveal } from "@/lib/motion";
import MaskLines from "@/components/MaskLines";

const SERVICES = [
  {
    cls: "service-0",
    img: "/assets/garage.webp",
    alt: "Sfeerbeeld van een opgeruimde garages",
    icon: "/assets/icon-0.png",
    title: "Garages",
    text: "Weer plek voor de auto, fiets of werkbank.",
    slug: "garages",
  },
  {
    cls: "service-1",
    img: "/assets/attic.webp",
    alt: "Sfeerbeeld van een opgeruimde zolders",
    icon: "/assets/icon-1.png",
    title: "Zolders",
    text: "Overzicht tussen dozen en herinneringen.",
    slug: "zolders",
  },
  {
    cls: "service-2",
    img: "/assets/shed.webp",
    alt: "Sfeerbeeld van een opgeruimde schuren",
    icon: "/assets/icon-2.png",
    title: "Schuren",
    text: "Ruimte tussen gereedschap en tuinspullen.",
    slug: "schuren",
  },
  {
    cls: "service-3",
    icon: "/assets/icon-3.png",
    title: "Bergingen",
    text: "Een vrije vloer en spullen die je terugvindt.",
    slug: "bergingen",
  },
];

export default function Services() {
  return (
    <section id="diensten" className="section services" data-testid="diensten">
      <MaskLines lines={["Waar kunnen we", "ruimte maken?"]} testId="diensten-titel" />
      <motion.p className="lead" {...reveal(0.08)}>
        Van een volle garage tot een vergeten zolder. We helpen je weer overzicht te krijgen.
      </motion.p>
      <div className="service-grid">
        {SERVICES.map((s, i) => (
          <motion.article
            key={s.slug}
            className={`service ${s.cls}`}
            {...reveal(i * 0.08, 18)}
            data-testid={`service-card-${s.slug}`}
          >
            {s.img ? <img className="service-photo" src={s.img} alt={s.alt} loading="lazy" /> : null}
            <div className="service-copy">
              <img src={s.icon} alt="" width="44" height="44" />
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          </motion.article>
        ))}
      </div>
      <p className="image-note">De beelden zijn sfeerimpressies, geen foto's van uitgevoerde klussen.</p>
    </section>
  );
}
